import { useState } from "react";
import { motion } from "framer-motion";

const TILE_BUBBLES = [
  { left: "25%", size: 10, dur: 1.6, delay: 0 },
  { left: "50%", size: 16, dur: 2.1, delay: 0.4 },
  { left: "72%", size: 8, dur: 1.4, delay: 0.8 },
];

export default function GalleryTile({ item, aspect = "aspect-[4/3] md:aspect-[4/3]", layout = false, priority = false }) {
  const [loaded, setLoaded] = useState(false);
  return (
    <motion.div
      layout={layout}
      initial={layout ? { opacity: 0, scale: 0.96 } : false}
      animate={layout ? { opacity: 1, scale: 1 } : undefined}
      exit={layout ? { opacity: 0, scale: 0.96 } : undefined}
      transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
      data-testid={`gallery-item-${item.src.split("/").pop().replace(".jpg", "")}`}
      className={`group relative overflow-hidden bg-[#003366] border border-[#007bff]/45 ${aspect}`}
    >
      <div
        aria-hidden
        className={`absolute inset-0 z-[5] bg-[#003366] overflow-hidden transition-opacity duration-400 ${
          loaded ? "opacity-0 pointer-events-none" : "opacity-100"
        }`}
      >
        {TILE_BUBBLES.map((b, i) => (
          <span
            key={i}
            className="tile-bubble"
            style={{ left: b.left, width: b.size, height: b.size, animationDuration: `${b.dur}s`, animationDelay: `${b.delay}s` }}
          />
        ))}
      </div>
      <img
        src={item.src}
        alt={`${item.caption} — ${item.category} by SAMI FAB, aluminium fabrication Albany WA`}
        loading={priority ? "eager" : "lazy"}
        fetchPriority={priority ? "high" : "auto"}
        decoding="async"
        onLoad={() => setLoaded(true)}
        className={`absolute inset-0 w-full h-full object-cover transition-[opacity,transform] duration-400 ease-out group-hover:scale-105 ${
          loaded ? "opacity-100" : "opacity-0"
        }`}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#003366]/85 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      <span
        aria-hidden
        className="absolute top-0 left-0 h-[3px] w-0 bg-[#007bff] transition-[width] duration-300 group-hover:w-full z-10"
      />
      <span className="absolute bottom-0 left-0 bg-white/95 px-2 py-1 md:px-3.5 md:py-2 font-mono text-[8px] md:text-[10px] font-bold uppercase tracking-[0.12em] md:tracking-[0.2em] text-[#003366] z-10">
        {item.caption}
      </span>
    </motion.div>
  );
}
